import * as constants from "./constants";

export const fetchMaterialControl = (data) => {
  return {
    type: constants.FETCH_MATERIAL_CONTROL,
    data: data,
  };
};

export const fetchMaterialControlSuccess = (data) => {
  return {
    type: constants.FETCH_MATERIAL_CONTROL_SUCCESS,
    data: data,
  };
};

export const fetchMaterialControlError = () => {
  return {
    type: constants.FETCH_MATERIAL_CONTROL_ERROR,
  };
};

export const fetchProjectActivities = (data) => {
  return {
    type: constants.FETCH_PROJECT_ACTIVITIES,
    data,
  };
};

export const fetchProjectActivitiesSuccess = (data) => {
  return {
    type: constants.FETCH_PROJECT_ACTIVITIES_SUCCESS,
    data: data,
  };
};

export const fetchProjectActivitiesSearchUtils = (data) => {
  return {
    type: constants.FETCH_PROJECT_ACTIVITIES_SEARCH_DATA,
    data,
  };
};

export const fetchProjectActivitiesSearchUtilsSuccess = (data) => {
  return {
    type: constants.FETCH_PROJECT_ACTIVITIES_SEARCH_DATA_SUCCESS,
    data: data,
  };
};

export const fetchProjectActivitiesSearchUtilsError = (data) => {
  return {
    type: constants.FETCH_PROJECT_ACTIVITIES_SEARCH_DATA_ERROR,
    data,
  };
};
export const updateProjectActivity = (data) => {
  return {
    type: constants.UPDATE_PROJECT_ACTIVITY,
    data: data,
  };
};

export const updateProjectActivitySuccess = (data) => {
  return {
    type: constants.UPDATE_PROJECT_ACTIVITY_SUCCESS,
    data: data,
  };
};

export const updateProjectActivityError = () => {
  return {
    type: constants.UPDATE_PROJECT_ACTIVITY_ERROR,
  };
};

export const deleteMaterialControl = (data) => {
  return {
    type: constants.DELETE_MATERIAL_CONTROL,
    data: data,
  };
};

export const deleteMaterialControlSuccess = (data) => {
  return {
    type: constants.DELETE_MATERIAL_CONTROL_SUCCESS,
    data: data,
  };
};

export const deleteMaterialControlError = () => {
  return {
    type: constants.DELETE_MATERIAL_CONTROL_ERROR,
  };
};

export const createMaterialControl = (data) => {
  return {
    type: constants.CREATE_MATERIAL_CONTROL,
    data: data,
  };
};

export const createMaterialControlSuccess = (data, closeMainForm = false) => {
  return {
    type: constants.CREATE_MATERIAL_CONTROL_SUCCESS,
    data: data,
    closeMainForm: closeMainForm,
  };
};

export const createMaterialControlError = () => {
  return {
    type: constants.CREATE_MATERIAL_CONTROL_ERROR,
  };
};

export const updateMaterialControl = (data) => {
  return {
    type: constants.UPDATE_MATERIAL_CONTROL,
    data: data,
  };
};

export const updateMaterialControlSuccess = (data) => {
  return {
    type: constants.UPDATE_MATERIAL_CONTROL_SUCCESS,
    data: data,
  };
};

export const updateMaterialControlError = () => {
  return {
    type: constants.UPDATE_MATERIAL_CONTROL_ERROR,
  };
};

export const deleteProjectDocAttach = (data) => {
  return {
    type: constants.DELETE_PROJECT_DOC_ATTACH,
    data: data,
  };
};

export const deleteProjectDocAttachSuccess = (data) => {
  return {
    type: constants.DELETE_PROJECT_DOC_ATTACH_SUCCESS,
    data: data,
  };
};

export const deleteProjectDocAttachError = () => {
  return {
    type: constants.DELETE_PROJECT_DOC_ATTACH_ERROR,
  };
};

export const updateProjectIsAddIsUpdate = (data) => {
  return {
    type: constants.UPDATE_PROJECT_ISADD_ISUPDATE,
    data,
  };
};

export const addProjectActivityAttach = (data) => {
  return {
    type: constants.ADD_PROJECT_DOC_ATTACH,
    data: data,
  };
};

export const fetchProjectBatchUpdate = (data) => {
  return {
    type: constants.FETCH_PROJECT_BATCH_UPDATE,
    data: data,
  };
};

export const fetchProjectBatchUpdateSuccess = (data) => {
  return {
    type: constants.FETCH_PROJECT_BATCH_UPDATE_SUCCESS,
    data: data,
  };
};

export const fetchProjectBatchUpdateError = () => {
  return {
    type: constants.FETCH_PROJECT_BATCH_UPDATE_ERROR,
  };
};

export const fetchMaterialControlById = (data) => {
  return {
    type: constants.FETCH_MATERIAL_CONTROL_BY_ID,
    data: data,
  };
};

export const fetchMaterialControlByIdSuccess = (data) => {
  return {
    type: constants.FETCH_MATERIAL_CONTROL_BY_ID_SUCCESS,
    data: data,
  };
};

export const fetchMaterialControlByIdError = () => {
  return {
    type: constants.FETCH_MATERIAL_CONTROL_BY_ID_ERROR,
  };
};

export const resetNewMaterialControl = () => {
  return {
    type: constants.RESET_NEW_MATERIAL_CONTROL,
  };
};

export const markItemAsReceived = (data) => {
  return {
    type: constants.MARK_ITEM_AS_RECEIVED,
    data: data,
  };
};

export const markItemAsReceivedSuccess = (data) => {
  return {
    type: constants.MARK_ITEM_AS_RECEIVED_SUCCESS,
    data: data,
  };
};

export const markItemAsReceivedError = () => {
  return {
    type: constants.MARK_ITEM_AS_RECEIVED_ERROR,
  };
};

export const markItemAsCompleted = (data) => {
  return {
    type: constants.MARK_ITEM_AS_COMPLETED,
    data: data,
  };
};

export const markItemAsCompletedSuccess = (data) => {
  return {
    type: constants.MARK_ITEM_AS_COMPLETED_SUCCESS,
    data: data,
  };
};

export const markItemAsCompletedError = () => {
  return {
    type: constants.MARK_ITEM_AS_COMPLETED_ERROR,
  };
};  

export const markItemAsReceivedUpdate = (data) => {
  return {
    type: constants.MARK_ITEM_AS_RECEIVED_UPDATE,
    data: data,
  };
};

export const markItemAsReceivedUpdateSuccess = (data) => {
    return {
        type: constants.MARK_ITEM_AS_RECEIVED_UPDATE_SUCCESS,
        data: data,
    };
};

export const markItemAsReceivedUpdateError = () => {
  return {
    type: constants.MARK_ITEM_AS_RECEIVED_UPDATE_ERROR,
  };
};

// Project completion data action creators
export const fetchProjectCompletionData = (data, searchResultIds) => {
  return {
    type: constants.FETCH_PROJECT_COMPLETION_DATA,
    data: data,
    searchResultIds: searchResultIds,
  };
};

export const fetchProjectCompletionDataSuccess = (data) => {
  return {
    type: constants.FETCH_PROJECT_COMPLETION_DATA_SUCCESS,
    data,
  };
};

export const fetchProjectCompletionDataError = () => {
  return {
    type: constants.FETCH_PROJECT_COMPLETION_DATA_ERROR,
  };
};
